import { useNormalizedPixels } from '../../../../../hooks/useResize';
import { BoxComponent } from '../../../../../base/box/Box';

interface OutOfStockProps {
  fontFamily?: string;
}

const OutOfStock = ({ fontFamily = 'sans-serif' }: OutOfStockProps) => {
  const { normalizePixels } = useNormalizedPixels();
  return (
    <BoxComponent
      sx={{
        width: 'fit-content',
        backgroundColor: '#FF7171',
        color: '#242528',
        fontSize: `${normalizePixels(12, 'height')}px`,
        textAlign: 'center',
        borderRadius: '20px',
        padding: '4px',
        paddingY: '2px',
        fontFamily: fontFamily,
      }}
    >
      Out of stock
    </BoxComponent>
  );
};

export default OutOfStock;
